import React from 'react';
import DevicesList from '#component/shipment/overview/devices-list';
import EventsList from '#component/general/simple-events/index';
import SidebarComponents from '#component/shipment/overview/shipment-timeline';
import { SidebarWrapper, StepProgressPaper } from './styles';

const Sidebar = props => {
  const {
    history,
    account,
    clickedDevices,
    clickedEvents,
    setClickedDevices,
    setClickedEvents,
    handleEventClick,
    handleEventHover,
    sidebarComponentsProps,
    sidebarDevicesProps,
    syncSelectedDevicesWithStore
  } = props;

  return (
    <SidebarWrapper
      item
      xs={12}
      md={3}
      className="leftSidebar"
      aria-label="Overview sidebar"
    >
      <StepProgressPaper elevation={0}>
        { clickedDevices.length ?
          <DevicesList
            account={account}
            devices={clickedDevices}
            closeList={setClickedDevices}
          /> :
          clickedEvents.length ?
            <EventsList
              events={clickedEvents}
              history={history}
              account={account}
              closeList={setClickedEvents}
              handleEventClick={handleEventClick}
              handleEventHover={handleEventHover}
              syncSelectedDevicesWithStore={syncSelectedDevicesWithStore}
            /> :
            <SidebarComponents
              handleClick={handleEventClick}
              handleHover={handleEventHover}
              syncSelectedDevicesWithStore={syncSelectedDevicesWithStore}
              {...sidebarComponentsProps}
              sidebarDevicesProps={sidebarDevicesProps}
            />}
      </StepProgressPaper>
    </SidebarWrapper>);
};

export default Sidebar;
